import React from 'react';
import { EnabledApp } from '@fabric-ui/components';
import { PagePathsValue } from '../context/AvContext.types';
import { Permission } from './permissions.types';
import { AppPathKey } from './routes.types';

/** Account state, resolved at runtime, that a menu item needs before it is shown. */
export enum NavRequirement {
  FreaProvisioned = 'freaProvisioned',
}

export interface MenuItem {
  name: string;
  ffForDisplaying?: string;
  ffForHiding?: string;

  subMenu: SubMenuItem[];
}

export type SubMenuItem = {
  path: PagePathsValue;
  name: string;
  icon?: React.JSX.Element;
  isBackOffice?: boolean;
  internalRoleOnly?: boolean;
  subMenu?: SubMenuItem[];
  parentPath?: string;
  permission?: Permission;
  permissionPath?: PagePathsValue;
  ffForDisplaying?: string;
  ffForHiding?: string;
  landingPage?: boolean;
  fixedTabHeight?: number;
  externalLink?: string;
  // Renders the expandable submenu even when only one child survives
  // permission/flag filtering (default collapses a single child into a
  // flat item). Used by the Account Settings > Account group.
  alwaysShowSubMenu?: boolean;
  // Children link to their own `path` directly instead of being nested under
  // the parent's path. For purely-visual grouping (Account Settings > Account).
  flatSubMenuPaths?: boolean;
  requires?: NavRequirement;
};

export type SideBarFooter = {
  title: string;
  value: string;
  ffForDisplaying?: string;
  // Also display when the account has an MDR product connected, regardless of ffForDisplaying.
  requiresMdrSubscription?: boolean;
};

export type App = EnabledApp<AppPathKey>;
